exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n[copy-to-clipboard] > i {\n\tfont-size: 1em;\n}\n*/\n", ""]);

// exports
